import React from "react";

export default ({children}) => (
  <div className="card-footer clearfix" >
    {children}
  </div>
);
